const routes = [
  { label: 'About Us', path: '/about-us' },
  { label: 'Our Solution', path: `/our-solution` },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Blog', path: '/blog' },
];

export default routes;
